<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="filteredDocumentTemplateLinking" :search="search"
        class="elevation-1 mytable" dense>
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Document Template Linking</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-row justify="center">
            <v-col cols="12" md="2">
              <v-autocomplete v-model="selectedStandard" :items="standard_list" item-text="name" item-value="id"
                outlined label="Standard" multiple chips small-chips clearable dense />
            </v-col>
            <v-col cols="12" md="2">
              <v-autocomplete v-model="selectedDescription" :items="descriptionList" label="Template Description"
                outlined multiple chips small-chips clearable dense />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details outlined
                dense />
            </v-col>
            <v-col cols="12" sm="6" md="3" class="d-flex justify-end">
              <v-dialog v-model="dialog" max-width="800px">
                <template v-slot:activator="{ on }">
                  <v-btn class="mb-2 button" v-on="on" small>Link Document Template</v-btn>
                </template>
                <v-card>
                  <v-form v-model="valid" ref="form">
                    <v-card-title class="toolbar">
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field v-model="editedItem.linking_date" type="date" :rules="[
                              (v) => !!v || 'Linking Date is required',
                              (v) => /^\d{4}-\d{2}-\d{2}$/.test(v) || 'Invalid date format'
                            ]" label="Linking Date" persistent-hint></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-autocomplete v-model="editedItem.standard_id" :items="standard_list" item-text="name"
                              item-value="id" label="Standard" persistent-hint
                              :rules="[(v) => !!v || 'Standard is required']" clearable :multiple="editedIndex === -1">
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-title>No Standards Loaded (Check Console)</v-list-item-title>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-autocomplete v-model="editedItem.documenttemplate_id" :items="documenttemplate_list"
                              item-text="name" item-value="id" label="Document Template" persistent-hint
                              :rules="[(v) => !!v || 'Document Template is required']" clearable>
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-title>No Document Templates Loaded (Check Console)</v-list-item-title>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-autocomplete v-model="editedItem.linkedby_id" :items="instructor_list" item-text="name"
                              item-value="id" label="Linked By" persistent-hint
                              :rules="[(v) => !!v || 'Linked By is required']" clearable>
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-title>No Faculty Loaded (Check Console)</v-list-item-title>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                      <v-btn class="mb-2 button" @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </template>

        <template v-slot:item.linking_date="{ item }">
          {{ formatDate(item.linking_date) }}
        </template>

        <template v-slot:item.documenttemplate_template="{ item }">
          <v-icon class="mr-2" size="25" color="info" @click="viewItem(item)">
            mdi-eye
          </v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-icon class="edit-v-icon mr-1" size="26" color="primary" @click="editItem(item)">edit</v-icon>
            <v-icon class="mr-2" size="25" @click="deleteItem(item)" color="error">mdi-delete</v-icon>
          </div>
        </template>
      </v-data-table>
      <v-dialog v-model="viewDialog" max-width="800px">
        <v-card>
          <v-card-title class="toolbar">
            <span class="headline">Template Preview</span>
          </v-card-title>

          <v-card-text style="max-height: 500px; overflow-y: auto;">
            <div>{{ viewTemplate }}</div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="viewDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    valid: false,
    overlay: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    selected_faculty: [],
    standard_list: [],
    documenttemplate_list: [],
    instructor_list: [],
    headers: [
      { text: "Linking Date", align: "center", sortable: true, value: "linking_date" },
      { text: "Standard", align: "center", sortable: false, value: "standard_name" },
      { text: "Document Template", align: "center", sortable: false, value: "documenttemplate_template" },
      { text: "Template Description", align: "center", sortable: false, value: "template_description" },
      { text: "Linked By", align: "center", sortable: false, value: "linkedby_name" },
      { text: "Actions", value: "action",align: "center", sortable: false },
    ],
    document_template_linking_list: [],
    editedIndex: -1,
    editedItem: {
      id: null,
      linking_date: "",
      standard_id: [],
      documenttemplate_id: null,
      linkedby_id: null,
      standard_name: "",
      documenttemplate_template: "",
      linkedby_name: "",
    },
    defaultItem: {
      id: null,
      linking_date: "",
      standard_id: [],
      documenttemplate_id: null,
      linkedby_id: null,
      standard_name: "",
      documenttemplate_template: "",
      linkedby_name: "",
    },
    viewDialog: false,
    viewTemplate: "",
    selectedStandard: [],
    selectedDescription: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Link Document Template" : "Edit Document Template Linking";
    },
    filteredDocumentTemplateLinking() {
      return this.document_template_linking_list.filter(item => {

        const standardMatch =
          this.selectedStandard.length === 0 ||
          this.selectedStandard.includes(item.standard_id);

        const descriptionMatch =
          this.selectedDescription.length === 0 ||
          this.selectedDescription.includes(item.template_description);

        return standardMatch && descriptionMatch;
      });
    },

    descriptionList() {
      return [...new Set(
        this.document_template_linking_list
          .map(item => item.template_description)
          .filter(Boolean)
      )];
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    selected_faculty() {
      this.onLoad();
    },
  },

  mounted() {
    this.onLoad();
  },

  methods: {
    viewItem(item) {
      this.viewTemplate = item.documenttemplate_template; // adjust if field name differs
      this.viewDialog = true;
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      try {
        let date;
        if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
          const [day, month, year] = dateStr.split("-");
          date = new Date(`${year}-${month}-${day}`);
        } else {
          date = new Date(dateStr);
        }
        if (isNaN(date.getTime())) {
          console.error("Invalid date:", dateStr);
          return dateStr;
        }
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (e) {
        console.error("Failed to format date:", dateStr, e);
        return dateStr;
      }
    },

    editItem(item) {
      this.editedIndex = this.document_template_linking_list.indexOf(item);
      this.editedItem = Object.assign({}, item);

      if (Array.isArray(this.editedItem.standard_id)) {
        this.editedItem.standard_id = this.editedItem.standard_id[0] || null;
      }

      if (item.linking_date) {
        try {
          let date;
          if (/^\d{2}-\d{2}-\d{4}$/.test(item.linking_date)) {
            const [day, month, year] = item.linking_date.split("-");
            date = new Date(`${year}-${month}-${day}`);
          } else {
            date = new Date(item.linking_date);
          }
          if (!isNaN(date.getTime())) {
            this.editedItem.linking_date = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
          } else {
            console.error("Invalid date for edit:", item.linking_date);
            this.editedItem.linking_date = "";
          }
        } catch (e) {
          console.error("Failed to parse date for edit:", item.linking_date, e);
          this.editedItem.linking_date = "";
        }
      } else {
        this.editedItem.linking_date = "";
      }
      this.dialog = true;
    },

    onLoad() {
      this.overlay = true;
      const payload = this.selected_faculty.length > 0 ? { selected_faculty: this.selected_faculty } : {};
      console.log("Sending payload:", payload);
      axios
        .post("/Examination/getDocumentTemplateLinking", payload)
        .then((res) => {
          console.log("Backend response:", res.data);
          this.overlay = false;
          if (res.data.document_template_linking_list) {
            this.document_template_linking_list = res.data.document_template_linking_list;
            this.standard_list = res.data.standard_list || [];
            this.documenttemplate_list = res.data.documenttemplate_list || [];
            this.instructor_list = res.data.instructor_list || [];
            console.log("Standard list:", this.standard_list);
            console.log("Document template list:", this.documenttemplate_list);
            console.log("Instructor list:", this.instructor_list);
            if (this.standard_list.length === 0) {
              this.showSnackbar("#ff9800", "No standards available");
            }
            if (this.documenttemplate_list.length === 0) {
              this.showSnackbar("#ff9800", "No document templates available");
            }
            if (this.instructor_list.length === 0) {
              this.showSnackbar("#ff9800", "No faculty data available");
            }
          } else if (res.data.msg === "401" || res.data.msg === "403") {
            this.showSnackbar("#b71c1c", "Unauthorized access");
          } else if (res.data.msg === "404") {
            this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
          } else if (res.data.msg === "400") {
            this.showSnackbar("#b71c1c", res.data.snackbar || "Invalid request data");
          } else {
            this.showSnackbar("#b71c1c", "Failed to load data");
          }
        })
        .catch((error) => {
          this.overlay = false;
          console.error("Axios error:", error);
          this.showSnackbar("#b71c1c", "Something went wrong...");
        });
    },

    deleteItem(item) {
      if (!confirm(`Are you sure you want to delete Document Template Linking for standard '${item.standard_name}' and template '${item.documenttemplate_template}'?`)) return;
      axios
        .post("/Examination/deleteDocumentTemplateLinking", { deleteid: item.id })
        .then((res) => {
          if (res.data.status && res.data.status.code === "SUCCESS") {
            this.showSnackbar("#4caf50", "Document Template Linking Deleted Successfully");
            this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", res.data.status ? res.data.status.message : "Failed to delete");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          console.error(error);
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.resetValidation();
      }, 300);
    },

    save() {
      // Sequential validation: show only the first error
      if (!this.editedItem.linking_date) {
        this.showSnackbar("#b71c1c", "Linking Date is required");
        return;
      }
      if (!/^\d{4}-\d{2}-\d{2}$/.test(this.editedItem.linking_date)) {
        this.showSnackbar("#b71c1c", "Invalid date format");
        return;
      }
      if (!this.editedItem.standard_id || this.editedItem.standard_id.length === 0) {
        this.showSnackbar("#b71c1c", "Standard is required");
        return;
      }
      if (!this.editedItem.documenttemplate_id) {
        this.showSnackbar("#b71c1c", "Document Template is required");
        return;
      }
      if (!this.editedItem.linkedby_id) {
        this.showSnackbar("#b71c1c", "Linked By is required");
        return;
      }

      const payload = {
        linking_date: this.editedItem.linking_date,
        standard_id: this.editedItem.standard_id,
        documenttemplate_id: this.editedItem.documenttemplate_id,
        linkedby_id: this.editedItem.linkedby_id,
      };

      if (this.editedIndex > -1) {
        // Edit
        payload.editid = this.editedItem.id;
        axios
          .post("/Examination/editDocumentTemplateLinking", payload)
          .then((res) => {
            if (res.data.status && res.data.status.code === "SUCCESS") {
              this.showSnackbar("#4caf50", "Document Template Linking Updated Successfully");
              this.onLoad();
            } else {
              this.showSnackbar("#b71c1c", res.data.status ? res.data.status.message : "Failed to update");
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            console.error(error);
          });
      } else {
        // Save new
        axios
          .post("/Examination/saveDocumentTemplateLinking", payload)
          .then((res) => {
            if (res.data.status && res.data.status.code === "SUCCESS") {
              this.showSnackbar("#4caf50", "Document Template Linking Added Successfully");
              this.onLoad();
            } else {
              this.showSnackbar("#b71c1c", res.data.status ? res.data.status.message : "Failed to add");
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            console.error(error);
          });
      }
      this.close();
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding-bottom: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}
</style>